
import React from 'react';
import { Badge } from '@/components/ui/badge';

interface OfferStatusBadgeProps {
  status: string;
}

const OfferStatusBadge: React.FC<OfferStatusBadgeProps> = ({ status }) => {
  const isActive = status === 'active';
  
  return (
    <Badge 
      variant={isActive ? 'success' : 'secondary'}
      className={isActive ? 'border-green-300 bg-green-50 text-green-500 hover:bg-green-100 dark:border-green-700 dark:bg-green-900/20 dark:text-green-400'
        : 'bg-gray-50 text-gray-800'}
    >
      {isActive ? 'Active' : 'Archived'}
    </Badge>
  );
};

export default OfferStatusBadge;
